// Live wager tax/commission percentages, sourced from the backend site-settings
// response (which reflects the admin master switch + editable values). Defaults
// to 0 until settings load, so nothing is shown before we know the real values.
let wagerConfig = { taxPercent: 0, commissionPercent: 0 };

/** Populate the wager tax/commission percentages from the site-settings API. */
export const setWagerConfig = (cfg = {}) => {
  wagerConfig = {
    taxPercent: Number(cfg.wagerTaxPercent) || 0,
    commissionPercent: Number(cfg.wagerCommissionPercent) || 0,
  };
};

export const getWagerConfig = () => wagerConfig;

const round2 = (n) => Number(Number(n).toFixed(2));

/** Round to 2 decimal places for wager math (risk, win, payout). */
export const roundMoney = round2;

export const computeWagerFinancials = ({
  wagerAmount = 0,
  payOut = 0,
  totalLossamount = 0,
  betType = "",
} = {}) => {
  let risk = 0;
  if (["Straight", "Parlay", "Teaser"].includes(betType)) {
    risk = Number(wagerAmount) || 0;
  } else {
    risk = Number(totalLossamount) || Number(wagerAmount) || 0;
  }

  const taxPercent = Number(wagerConfig.taxPercent) || 0;
  const commissionPercent = Number(wagerConfig.commissionPercent) || 0;

  const grossPayout = Number(payOut) || 0;
  const winAmount = round2(Math.max(0, grossPayout - risk));
  const taxAmount = round2((winAmount * taxPercent) / 100);
  const commissionAmount = round2((risk * commissionPercent) / 100);
  const totalPayout = round2(
    Math.max(0, grossPayout - taxAmount - commissionAmount)
  );

  return {
    riskAmount: round2(risk),
    winAmount,
    taxAmount,
    commissionAmount,
    grossPayout: round2(grossPayout),
    totalPayout,
    taxPercent,
    commissionPercent,
  };
};

/** Use API-enriched fields when present, otherwise compute locally. */
export const getTicketFinancials = (item) => {
  if (!item) {
    return computeWagerFinancials();
  }
  return computeWagerFinancials({
    wagerAmount: item.wagerAmount,
    payOut: item.payOut,
    totalLossamount: item.totalLossamount,
    betType: item.betType,
  });
};

export const formatMoney = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return "0.00";
  return x.toFixed(2);
};

/** Win from risk at American odds (e.g. -200 on $300 risk → $150). */
export const calcWinFromRisk = (risk, odds) => {
  if (!risk || !odds) return 0;
  const win =
    odds > 0 ? (risk * odds) / 100 : (risk * 100) / Math.abs(odds);
  return roundMoney(win);
};

/** Risk required to win a given amount at American odds. */
export const calcRiskFromWin = (win, odds) => {
  if (!win || !odds) return 0;
  const risk =
    odds > 0 ? (win * 100) / odds : (win * Math.abs(odds)) / 100;
  return roundMoney(risk);
};
